var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { COLORS } from '../../../../constants';
export function inputStyles(isActive) {
  return {
    '& input': __assign({
      textOverflow: 'ellipsis'
    }, isActive ? {
      border: "solid 1px " + COLORS.blues.primary + " !important",
      color: COLORS.blues.primary + " !important"
    } : {}),
    '& input[type]': {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&:focus': {
        border: "solid 1px " + COLORS.blues.primary,
        outline: 'none',
        boxShadow: 'none'
      }
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/search/input.js
// module id = 1026
// module chunks = 0